import { difference } from 'lodash/fp'
import { BulkExportCultureMetadataResponse } from '~/api/backend/pages/bulkExportCultureMetadataAPI'

export const getMissingPlates = (
  data: BulkExportCultureMetadataResponse | null,
  plateBarcodesToDisplay: string[],
) => {
  if (!data) return plateBarcodesToDisplay

  const plateBarcodesInData = data.filteredCulturePlatesWithWells.map(
    plate => plate.barcode,
  )
  const missingPlates = difference(plateBarcodesToDisplay, plateBarcodesInData)

  return missingPlates
}
